
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/[termId]",
      function () {
        return require("private-next-pages/terms/[termId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/[termId]"])
      });
    }
  